import React from 'react';
import { useNavigate } from 'react-router-dom';
import Notaccepting from "../../assets/images/not-accepting.gif";

interface NotAcceptingFormProps {
  isEmbedded?: boolean;
}

const NotAcceptingForm: React.FC<NotAcceptingFormProps> = ({ isEmbedded = false }) => {
  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate('/');
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <img src={Notaccepting} alt='Not Accepting Form' style={{ width: '100px', marginBottom: '1rem' }} />
        <h1 style={styles.heading}>Form Not Accepting Responses</h1>
        <p style={styles.paragraph}>We're not accepting responses at this time. Please try again later.</p>
        {!isEmbedded && (
          <button onClick={handleButtonClick} style={styles.button}>
            Go to Homepage
          </button>
        )}
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    padding: '1rem',
    background: 'linear-gradient(to right, #e0eafc, #cfdef3)',
  },
  card: {
    backgroundColor: '#ffffff',
    padding: '3rem',
    borderRadius: '0.75rem',
    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)',
    maxWidth: '650px',
    textAlign: 'center' as 'center',
  },
  heading: {
    fontSize: '2rem',
    color: '#1f2937', // dark gray
    marginBottom: '1rem',
    fontWeight: '600',
  },
  paragraph: {
    fontSize: '1.125rem',
    color: '#4b5563', // medium gray
    marginBottom: '2rem',
    lineHeight: '1.6',
  },
  button: {
    padding: '0.75rem 1.5rem',
    fontSize: '1rem',
    fontWeight: 500,
    color: '#fff',
    backgroundColor: '#2ca9b8',
    border: 'none',
    borderRadius: '0.375rem',
    cursor: 'pointer',
    boxShadow: '0 4px 14px rgba(0, 0, 0, 0.1)',
    transition: 'background-color 0.3s ease, transform 0.2s ease',
  },
};

export default NotAcceptingForm;
